export class ApiError extends Error {
  readonly status: number | undefined;

  readonly code: string | undefined;

  constructor(message: string, status: number | undefined, code?: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
  }
}

export function apiError(
  error: unknown,
  response: Response | undefined,
  fallback: string,
): ApiError {
  return new ApiError(errorDetail(error, fallback), response?.status, errorCode(error));
}

function errorCode(error: unknown): string | undefined {
  if (error && typeof error === "object" && "code" in error) {
    const code = (error as { code: unknown }).code;
    if (typeof code === "string" && code !== "") {
      return code;
    }
  }
  return undefined;
}

const UNREACHABLE_MESSAGE = "No pudimos hablar con el servidor. Probá de nuevo en unos segundos.";

export function reachabilityMessage(cause: unknown, offlineMessage: string): string {
  if (cause instanceof ApiError) {
    if (cause.status === undefined && !navigator.onLine) {
      return offlineMessage;
    }
    return cause.message;
  }
  if (!navigator.onLine) {
    return offlineMessage;
  }
  return UNREACHABLE_MESSAGE;
}

export function errorDetail(error: unknown, fallback: string): string {
  if (error && typeof error === "object" && "detail" in error) {
    const detail = (error as { detail: unknown }).detail;
    if (typeof detail === "string") {
      return detail;
    }
    if (Array.isArray(detail) && detail.length > 0) {
      const first = detail[0];
      if (first && typeof first === "object" && "msg" in first) {
        const msg = (first as { msg: unknown }).msg;
        if (typeof msg === "string") {
          return msg;
        }
      }
    }
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}
